<div class="fm">
  <div class="fm-ugyfel">
    <div class="fm-ugyfel-bal">
      <span class="fm-mod" [class.kettos]="aktiv.konyveles_mod === 'kettos'">
        {{ aktiv.konyveles_mod === 'kettos' ? 'Kettős könyvvitel' : 'Egyszeres könyvvitel' }}
      </span>
      <h1>{{ aktiv.ugyfelNev }}</h1>
      <span class="fm-ev">{{ aktiv.ev }}. év</span>
    </div>
    <div class="fm-ugyfel-gombok">
      <!--  ELSŐ BEÁLLÍTÁS – kompakt belépési pont a beállító varázslóhoz (a „Másik ügyfél" mellett).
            Piros, ha a varázsló lépései közül nincs mind kész (beallitasHianyos). -->
      <a class="fm-elso-link" routerLink="/naplo/elso-beallitas" [class.fm-elso-hianyos]="beallitasHianyos"
         [title]="beallitasHianyos
           ? 'Első beállítás – van még hiányzó lépés (nyitó, bank, KAÜ, önkormányzat, NAV). Kattints az ellenőrzéshez.'
           : 'Első beállítás – a könyvelés indításához szükséges lépések ellenőrzése'">
        <ion-icon [name]="beallitasHianyos ? 'alert-circle-outline' : 'rocket-outline'"></ion-icon> Első beállítás
      </a>
      <a class="fm-csere" routerLink="/naplo/ugyfelek"><ion-icon name="swap-horizontal-outline"></ion-icon> Másik ügyfél</a>
    </div>
  </div>

  <!-- FŐMENÜK -->
  <div class="fm-fomenuk">
    <button *ngFor="let x of menuk" type="button" class="fm-fomenu" [class.aktiv]="valasztott === x.f.kulcs" (click)="valaszt(x.f.kulcs)">
      <ion-icon [name]="x.f.ikon"></ion-icon>
      <span><u>{{ x.f.cim[0] }}</u>{{ x.f.cim.slice(1) }}</span>
    </button>
  </div>

  <div class="fm-elvalaszto"></div>

  <!--  NYITATLAN ÉV: a csempék halványak, és egy sávból egy kattintással a nyitáshoz lehet jutni.
        Kettős könyvvitelnél a könyvelés a nyitó egyenlegekkel kezdődik. -->
  <div class="fm-nyitas" *ngIf="nyitasKell" (click)="nyitasraUgras()">
    <ion-icon name="lock-closed-outline"></ion-icon>
    <div>
      <b>A(z) {{ aktiv.ev }}. év még nincs megnyitva.</b>
      {{ zarasAllapot?.kezdo_ev
        ? 'Kezdő év: a nyitó egyenlegeket kézzel kell felvinni (Nyitás / zárás → Nyitó egyenlegek kézzel).'
        : 'Nyisd meg az évet az előző év zárómérlegéből (Nyitás / zárás).' }}
    </div>
    <ion-icon name="chevron-forward-outline" class="fm-nyitas-nyil"></ion-icon>
  </div>

  <!-- A kiválasztott főmenü almenüi -->
  <div class="fm-csempek">
    <!--  Nyitatlan évben csak a Nyitás / zárás csempe él; a többi szürke és nem kattintható. -->
    <button *ngFor="let p of pontok" type="button" class="fm-csempe" [class.tiltott]="tiltott(p)"
            [disabled]="tiltott(p)" [title]="tiltott(p) ? 'Előbb nyisd meg a(z) ' + aktiv.ev + '. évet (Nyitás / zárás).' : ''"
            (click)="nyit(p)">
      <ion-icon [name]="p.ikon"></ion-icon>
      <span class="fm-csempe-cim">{{ p.cim }}</span>
      <span class="fm-csempe-leiras">{{ p.leiras }}</span>
    </button>
  </div>

  <div class="ures" *ngIf="!menuk.length">
    <ion-icon name="lock-closed-outline"></ion-icon>
    Ehhez az intézményhez nincs egyetlen könyvelési képernyőre sem jogosultságod.
  </div>

  <p class="fm-sugo">Tipp: a főmenük a fejlécből is nyithatók, billentyűzettel <b>{{ modBillNev }} + az aláhúzott betű</b>.</p>
</div>
